/***************************************
 ****** Package Definitions ************
 ***************************************/
const packageSelections = [
    {
        value: 'gusset',
        label: 'Gusset Bags',
        minimumQuantityUpload: 500,
        minimumQuantityDesignLab: 25,
        imageUrl:
            'https://a-us.storyblok.com/f/1003833/2000x2000/d1c8611393/gusset_package.png',
        selected: false,
        disabled: false,
        errored: false,
    },
    {
        value: 'flat-bottom',
        label: 'Flat Bottom Bags',
        minimumQuantityUpload: 1000,
        minimumQuantityDesignLab: 100,
        imageUrl:
            'https://a-us.storyblok.com/f/1003833/1080x1080/830c06120f/flat_bottom_package.png',
        selected: false,
        disabled: false,
        errored: false,
    },
    {
        value: 'can',
        label: 'Tin Cans',
        minimumQuantityUpload: 50,
        minimumQuantityDesignLab: 1,
        imageUrl:
            'https://a-us.storyblok.com/f/1003833/2000x2000/aeb0a289f1/tin_can_package.png',
        selected: false,
        disabled: false,
        errored: false,
    },
    {
        value: 'paper-tube',
        label: 'Paper Tubes',
        minimumQuantityUpload: 100,
        minimumQuantityDesignLab: null,
        imageUrl:
            'https://a-us.storyblok.com/f/1003833/1328x1328/23961ee969/paper_tube_package.png',
        selected: false,
        disabled: false,
        errored: false,
    },
    {
        value: 'stand-up',
        label: 'Stand Up Pouch',
        minimumQuantityUpload: 1000,
        minimumQuantityDesignLab: 25,
        imageUrl:
            'https://a-us.storyblok.com/f/1003833/1080x1080/b141caa345/stand_up_pouch_package.png',
        selected: false,
        disabled: false,
        errored: false,
    },
    {
        value: 'flat',
        label: 'Flat Pouch',
        minimumQuantityUpload: 1000,
        minimumQuantityDesignLab: null,
        imageUrl:
            'https://a-us.storyblok.com/f/1003833/1080x1080/bed38e8c90/flat_pouch_package.png',
        selected: false,
        disabled: false,
        errored: false,
    },
];

const quantityPackageBreaks = [
    {
        value: 1,
        label: '1',
        selected: false,
        disabled: false,
        errored: false,
    },
    {
        value: 25,
        label: '25',
        selected: false,
        disabled: false,
        errored: false,
    },
    {
        value: 100,
        label: '100',
        selected: false,
        disabled: false,
        errored: false,
    },
    {
        value: 500,
        label: '500',
        selected: false,
        disabled: false,
        errored: false,
    },
    {
        value: 1000,
        label: '1,000',
        selected: false,
        disabled: false,
        errored: false,
    },
    {
        value: 5000,
        label: '5,000',
        selected: false,
        disabled: false,
        errored: false,
    },
    {
        value: 10000,
        label: '10,000',
        selected: false,
        disabled: false,
        errored: false,
    },
    {
        value: 20000,
        label: '20,000',
        selected: false,
        disabled: false,
        errored: false,
    },
    {
        value: 50000,
        label: '50,000',
        selected: false,
        disabled: false,
        errored: false,
    },
];

const designPackageOptionsSelections = [
    {
        value: 'roastar_design_lab',
        label: 'Roastar Design Lab',
        subLabel: 'Use our easy online design tool',
        imageUrl:
            'https://a-us.storyblok.com/f/1003833/1080x1080/d6ccdcd3af/roastar_design_lab.png',
    },
    {
        value: 'upload_your_own',
        label: 'Upload Your Own',
        subLabel: 'Use our templates with design software',
        imageUrl:
            'https://a-us.storyblok.com/f/1003833/1280x1280/f0aaf2f210/upload_your_own.png',
    },
];

/***************************************
 ****** Sticker Definations ************
 ***************************************/
const designStickerOptionsSelections = [
    {
        value: 'upload_your_own',
        label: 'Upload Your Own',
        subLabel: 'Use our templates with design software',
        imageUrl:
            'https://a-us.storyblok.com/f/1003833/1280x1280/f0aaf2f210/upload_your_own.png',
    },
];
const stickerSelections = [
    {
        value: 'custom',
        label: 'Custom Die-Cut Stickers',
        minimumQuantity: 100,
        imageUrl:
            'https://a-us.storyblok.com/f/1003833/1343x1343/6c6fb13ed2/custom_die_cut_stickers.png',
        selected: false,
        disabled: false,
        errored: false,
    },
    {
        value: 'circle-or-oval',
        label: 'Circle/Oval Stickers',
        minimumQuantity: 100,
        imageUrl:
            'https://a-us.storyblok.com/f/1003833/1012x1012/ac45fcc20c/circle_oval_stickers.png',
        selected: false,
        disabled: false,
        errored: false,
    },
    {
        value: 'square-or-rectangle',
        label: 'Square/Rectangle Stickers',
        minimumQuantity: 100,
        imageUrl:
            'https://a-us.storyblok.com/f/1003833/944x944/553d7d26e3/square_rectangle_stickers.png',
        selected: false,
        disabled: false,
        errored: false,
    },
    {
        value: 'bag-label',
        label: 'Coffee Bag Labels',
        minimumQuantity: 50,
        imageUrl:
            'https://a-us.storyblok.com/f/1003833/864x864/b492a311e8/coffee_bag_labels_stickers.png',
        selected: false,
        disabled: false,
        errored: false,
    },
    {
        value: 'beverage-label',
        label: 'Beverage Labels',
        minimumQuantity: 100,
        imageUrl:
            'https://a-us.storyblok.com/f/1003833/664x664/d08dd4a187/beverage_labels_stickers.png',
        selected: false,
        disabled: false,
        errored: false,
    },
];
const quantityStickerBreaks = [
    {
        value: 50,
        label: '50',
        selected: false,
        disabled: false,
        errored: false,
    },
    {
        value: 100,
        label: '100',
        selected: false,
        disabled: false,
        errored: false,
    },
    {
        value: 200,
        label: '200',
        selected: false,
        disabled: false,
        errored: false,
    },
    {
        value: 300,
        label: '300',
        selected: false,
        disabled: false,
        errored: false,
    },
    {
        value: 500,
        label: '500',
        selected: false,
        disabled: false,
        errored: false,
    },
    {
        value: 1000,
        label: '1,000',
        selected: false,
        disabled: false,
        errored: false,
    },
    {
        value: 2500,
        label: '2500',
        selected: false,
        disabled: false,
        errored: false,
    },
    {
        value: 5000,
        label: '5,000',
        selected: false,
        disabled: false,
        errored: false,
    },
    {
        value: 10000,
        label: '10,000',
        selected: false,
        disabled: false,
        errored: false,
    },
    {
        value: null,
        label: 'Other',
        selected: false,
        disabled: false,
        errored: false,
    },
];

const productOptions = [
    {
        value: 'package',
        label: 'Packaging',
        routerValue: '#package',
        imageUrl:
            'https://a-us.storyblok.com/f/1003833/1390x1390/f0e7ce8ea4/package.png',
        selected: false,
        disabled: false,
        errored: false,
    },
    {
        value: 'sticker',
        label: 'Stickers & Labels',
        routerValue: '#sticker',
        imageUrl:
            'https://a-us.storyblok.com/f/1003833/864x864/ec800312d2/sticker.png',
        selected: false,
        disabled: false,
        errored: false,
    },
];
export {
    designPackageOptionsSelections,
    designStickerOptionsSelections,
    packageSelections,
    quantityPackageBreaks,
    quantityStickerBreaks,
    stickerSelections,
    productOptions,
};
